import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54d1e924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Background Frame", -1))
const _hoisted_3 = { class: "row d-flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Location", -1))
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Points", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          prop: "backgroundColor",
          label: "Background Color"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_color_picker, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.backgroundColor,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Use Background Media" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.useBackgroundMedia,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.useBackgroundMedia) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useBackgroundMedia)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Background Media"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "true",
                  sizeLimitMB: "300",
                  layoutProperty: "asset1",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "locationLabel",
          label: "Location Label"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.locationLabel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.locationLabel) = $event)),
              placeholder: "Location Label",
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "location",
          label: "Location"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.location,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.location) = $event)),
              placeholder: "Location",
              maxlength: "3"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "locationBackground",
            label: "Location Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.locationBackground,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.locationBackground) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "locationFontColor",
            label: "Location Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.locationFontColor,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.locationFontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_draggable, {
          class: "p-0 m-0",
          handle: ".drag",
          modelValue: _ctx.signageItemLayoutData.waypoints,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageItemLayoutData.waypoints) = $event)),
          tag: "ul",
          "item-key": "id"
        }, {
          item: _withCtx(({element, index}) => [
            _createElementVNode("li", {
              class: _normalizeClass(["d-flex align-items-center", { 'mb-2' : index < _ctx.signageItemLayoutData.waypoints.length }])
            }, [
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Reorder",
                placement: "bottom",
                "hide-after": 0,
                "show-after": 500
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    class: "mx-2 drag",
                    icon: _ctx.mdiDragHorizontalVariant
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                class: "flex-grow-1",
                modelValue: _ctx.signageItemLayoutData.waypoints[index],
                "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData.waypoints[index]) = $event),
                placeholder: "Name"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Duplicate",
                placement: "bottom",
                "hide-after": 0,
                "show-after": 500
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.signageItemLayoutData.waypoints.splice(index, 0 , element)),
                    type: "button",
                    class: "dt-icon-button"
                  }, [
                    _createVNode(_component_Icon, { icon: _ctx.mdiContentDuplicate }, null, 8, ["icon"])
                  ], 8, _hoisted_8)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Delete",
                placement: "bottom",
                "hide-after": 0,
                "show-after": 500
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.signageItemLayoutData.waypoints.splice(index, 1)),
                    type: "button",
                    class: "dt-icon-button"
                  }, [
                    _createVNode(_component_Icon, { icon: _ctx.mdiClose }, null, 8, ["icon"])
                  ], 8, _hoisted_9)
                ]),
                _: 2
              }, 1024)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            class: "mt-2 mb-4",
            type: "primary",
            plain: "",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.signageItemLayoutData.waypoints.push('')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add a Waypoint")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "waypointsBackground",
            label: "Waypoints Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.waypointsBackground,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.signageItemLayoutData.waypointsBackground) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "waypointsFontColor",
            label: "Waypoints Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.waypointsFontColor,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.signageItemLayoutData.waypointsFontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}